export const gad7_catalog = [
    "Se ha sentido nervioso(a) o con los nervios de punta",
    "No ha sido capaz de parar o controlar su preocupación",
    "Se ha preocupado demasiado por motivos diferentes",
    "Ha tenido dificultad para relajarse",
    "Se ha sentido tan inquieto(a) que no ha podido quedarse quieto(a)",
    "Se ha molestado o irritado fácilmente",
    "Ha tenido miedo de que algo terrible fuera a pasar"
]